
<template>
  <div>
    <Grid
      :service="service"
      defaultOrderColumn="created_date_formatted"
      defaultOrderDirection="asc"
      route_name="intimidation_form_handling"
      :ref="'grid'"
      :css_formats="{
        validated_date_formatted: (name, model) => {
          if(name){
            return `badge badge-glow badge-${model.status_label}`
          }else{
            return ''
          }
        }
      }">
      <template v-slot:actions="actions">
        <div class="flex flex-row gap-2">
          <feather-icon
            v-permission="`intimidation_form_handling.handling`"
            icon="EditIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Tratar formulário',
              delay: { show: 100, hide: 100 }
            }"
            @click="handling(actions.row.id)"
          />
          <feather-icon
            v-permission="`intimidation_form_handling.detail`"
            icon="EyeIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Detalhar registro',
              delay: { show: 100, hide: 100 }
            }"
            @click="detail(actions.row.id)"/>

          <feather-icon
            v-permission="`intimidation_form_handling.delete`"
            icon="Trash2Icon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
            v-tooltip.top="{
              content: 'Excluir registro',
              delay: { show: 100, hide: 100 }
            }"
            @click="destroy(actions.row.id)"/>
        </div>
      </template>
    </Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'

import SystematicIntimidationFormHandlingService from '@/services/api/intimidation/SystematicIntimidationFormHandlingService'

export default {
  directives: {
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    grid() {
      return this.$refs['grid']
    },
    handling(id) {
      this.$router.push(`/intimidation-form/${id}/handling`)
    },
    detail(id) {
      this.$router.push(`/intimidation-form/${id}`)
    },
    destroyModel(id) {
      this.$vs.loading()
      this.service.destroy(id).then(
        response => {
          this.notifySuccess(this.$vs, 'Registro excluído com sucesso!')
          this.grid().fetchGridData()
        },
        error => {
          this.notifyError(this.$vs, 'Não foi possível excluir o registro especificado')
        }
      ).finally(
        () => this.$vs.loading.close()
      )
    },
    destroy(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.destroyModel(id)
        }
      })
    }
  },
  beforeMount() {
    this.service = SystematicIntimidationFormHandlingService.build(this.$vs)
  }
}
</script>
